// @ts-nocheck
import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { useListDevices } from "./api-client-react";

const API = import.meta.env.VITE_API_URL ?? "";

interface AiBotCtx {
  enabled: boolean | null;
  deviceId: number | null;
  toggle: () => Promise<void>;
  syncEnabled: (v: boolean) => void;
}

const Ctx = createContext<AiBotCtx>({
  enabled: null,
  deviceId: null,
  toggle: async () => {},
  syncEnabled: () => {},
});

export function AiBotProvider({ children }: { children: React.ReactNode }) {
  const { data: devices } = useListDevices();
  const [enabled, setEnabled] = useState<boolean | null>(null);
  const [deviceId, setDeviceId] = useState<number | null>(null);

  useEffect(() => {
    if (!devices?.length) return;
    const dev = devices.find((d: any) => d.status === "connected") ?? devices[0];
    setDeviceId(dev.id);
    fetch(`${API}/api/aibot/${dev.id}`)
      .then(r => r.json())
      .then(data => setEnabled(data?.enabled ?? false))
      .catch(() => {});
  }, [devices]);

  const toggle = useCallback(async () => {
    if (deviceId === null || enabled === null) return;
    const next = !enabled;
    try {
      await fetch(`${API}/api/aibot/${deviceId}/toggle`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ enabled: next }),
      });
      setEnabled(next);
    } catch {}
  }, [deviceId, enabled]);

  const syncEnabled = useCallback((v: boolean) => setEnabled(v), []);

  return (
    <Ctx.Provider value={{ enabled, deviceId, toggle, syncEnabled }}>
      {children}
    </Ctx.Provider>
  );
}

export function useAiBot() {
  return useContext(Ctx);
}
